import { modalController } from '@ionic/core';
import { Component, Event, EventEmitter, Fragment, h, Prop } from '@stencil/core';
import { PersonDoc } from 'common';
import { PeopleService } from 'src/global/service/PeopleService';

@Component({
  tag: 'person-info-modal',
})
export class PersonInfoModal {
  static stringToRichText(str: string, people: PersonDoc[], eventName: string = 'showPersonInfo'): string {
    if (!str) return '';
    let emailsInStri = str.match(/([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi) || [];
    emailsInStri.forEach(email => {
      const person = PeopleService.findPersonByEmail(people, email);
      if (person) {
        const callback: string = `document.dispatchEvent(new CustomEvent('${eventName}', {detail: '${person._id}'}))`;
        str = str.replace(email, `<a href="#" onClick="${callback}; return false;">${PeopleService.getFullName(person)}</a>`);
      }
    });
    return str;
  }

  static async presentModal(person: PersonDoc): Promise<void> {
    const modal = await modalController.create({
      component: 'person-info-modal',
      cssClass: 'modal-height-auto concourse-modal',
      componentProps: { person },
    });

    modal.addEventListener('dismiss', () => {
      modal.dismiss();
    });

    return await modal.present();
  }

  @Prop() person: PersonDoc;
  @Event() dismiss: EventEmitter;

  get initials() {
    const fname = this.person.first_name;
    const lname = this.person.last_name;

    if (!fname) return null;

    let firstLetter: string = fname ? fname.charAt(0) : '';
    let secondLetter: string = lname ? lname.charAt(0) : fname.charAt(1);
    return String(firstLetter + secondLetter).toUpperCase();
  }

  render() {
    return (
      <Fragment>
        <modal-header modalTitle={PeopleService.getFullName(this.person)} onDismiss={() => this.dismiss.emit()}></modal-header>
        <ion-page class="ion-padding">
          <div class="ion-display-flex">
            <div style={{ width: '70px', height: '48px', position: 'relative' }}>
              <concourse-avatar initials={this.initials} imageUrl={PeopleService.getIcon(this.person)} color={this.person.color} />
            </div>
            <div>
              <p class="ion-no-margin">{this.person.email}</p>
              <p class="ion-no-margin">
                {this.person.company_role ? `${this.person.company_role} at` : ''} {this.person.company}
              </p>
              <p class="ion-no-margin">{this.person.phone}</p>
              <p class="ion-no-margin">{this.person.phone_mobile}</p>
            </div>
          </div>
        </ion-page>
      </Fragment>
    );
  }
}
